.content-container {
    width: 100%;
    max-width: 1000px;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 64px;
    align-items: center;
    justify-content: center;
    padding: 64px;
    box-sizing: border-box;
    margin: 0 auto;
}
